/* SDS Pilates — interactions des sections SDS (vidéos, ajout rapide, onglets, look, page produit) */
(function () {
  if (window.__sdsInit) return; window.__sdsInit = true;
  var S = window.SDS || {};
  var root = (S.root && S.root !== '/') ? S.root.replace(/\/$/, '') : '';
  function fmt(cents) {
    try { return new Intl.NumberFormat(S.locale || document.documentElement.lang || 'fr-FR', { style: 'currency', currency: S.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* ---------- PANIER ---------- */
  function refreshCart() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-sds-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('[data-sds-ship]').forEach(function (el) {
        var th = +el.dataset.threshold || 10000, left = th - cart.total_price;
        var t = el.querySelector('[data-sds-ship-text]'), f = el.querySelector('[data-sds-ship-fill]');
        if (t) t.textContent = left <= 0 ? 'Livraison offerte débloquée ✓' : 'Plus que ' + fmt(left) + ' pour la livraison offerte';
        if (f) f.style.width = Math.min(100, cart.total_price / th * 100) + '%';
      });
      // Thèmes type Dawn : rafraîchit la bulle du panier
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        fetch(root + '/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) {
          if (d && d['cart-icon-bubble']) {
            var tmp = document.createElement('div'); tmp.innerHTML = d['cart-icon-bubble'];
            var inner = tmp.querySelector('.shopify-section') || tmp; bubble.innerHTML = inner.innerHTML;
          }
        }).catch(function () {});
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      return cart;
    });
  }
  function themeCart() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function') return { el: d, sections: ['cart-drawer', 'cart-icon-bubble'] };
    var n = document.querySelector('cart-notification');
    if (n && typeof n.open === 'function') return { el: n, sections: ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'] };
    return null;
  }
  function openThemeCart(tc, j) {
    var item = (j.items && j.items[0]) || j, secs = j.sections || {};
    try {
      if (tc.el.tagName.toLowerCase() === 'cart-drawer') {
        var inner = tc.el.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
        tc.el.classList.remove('is-empty');
        tc.el.renderContents({ id: item.variant_id, key: item.key, sections: secs });
        return;
      }
      var parse = function (html, sel) { var doc = new DOMParser().parseFromString(html || '', 'text/html'); var n = doc.querySelector(sel); return n ? n.innerHTML : null; };
      var map = { 'cart-notification-product': '[id="cart-notification-product-' + item.key + '"]', 'cart-notification-button': '.shopify-section', 'cart-icon-bubble': '.shopify-section' };
      Object.keys(map).forEach(function (id) {
        var el = document.getElementById(id); if (!el || !secs[id]) return;
        var h = parse(secs[id], map[id]); if (h !== null) el.innerHTML = h;
      });
      tc.el.cartItemKey = item.key;
      tc.el.open();
    } catch (e) { console.warn('SDS: pop-up panier du thème indisponible', e); }
  }
  function addToCart(items) {
    var tc = themeCart(), body = { items: items };
    if (tc) { body.sections = tc.sections.join(','); body.sections_url = window.location.pathname; }
    return fetch(root + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); })
      .then(function (j) { refreshCart(); if (tc) openThemeCart(tc, j); return j; });
  }
  S.addToCart = addToCart; S.refreshCart = refreshCart; window.SDS = S;

  /* ---------- CARTES PRODUIT ---------- */
  function variantsOf(card) {
    if (!card._v) { var s = card.querySelector('[data-sds-variants]'); card._v = s ? JSON.parse(s.textContent) : []; }
    return card._v;
  }
  function cardColor(card) { return card.dataset.color || null; }
  function findVariant(card, size) {
    var sp = +card.dataset.sizePos, cp = +card.dataset.colorPos, c = cardColor(card);
    return variantsOf(card).find(function (v) {
      return (sp < 0 || v.options[sp] === size) && (cp < 0 || !c || v.options[cp] === c);
    });
  }
  function markSizes(card) {
    card.querySelectorAll('[data-sds-size]').forEach(function (b) {
      var v = findVariant(card, b.dataset.sdsSize);
      b.classList.toggle('is-out', !v || !v.available);
      b.classList.toggle('is-on', card.dataset.size === b.dataset.sdsSize);
    });
  }
  function msg(card, text, ms) {
    var m = card.querySelector('[data-sds-msg]'); if (!m) return;
    if (!m.dataset.base) m.dataset.base = m.textContent;
    m.textContent = text;
    clearTimeout(m._t); if (ms) m._t = setTimeout(function () { m.textContent = m.dataset.base; }, ms);
  }
  document.querySelectorAll('[data-sds-product]').forEach(markSizes);

  document.addEventListener('click', function (e) {
    var t = e.target;
    var sw = t.closest('[data-sds-color]');
    if (sw) {
      var card = sw.closest('[data-sds-product]'); if (!card) return;
      card.dataset.color = sw.dataset.sdsColor;
      card.querySelectorAll('[data-sds-color]').forEach(function (b) { b.classList.toggle('is-on', b === sw); });
      var lab = card.querySelector('[data-sds-color-label]'); if (lab) lab.textContent = sw.dataset.sdsColor;
      var cp = +card.dataset.colorPos;
      var withImg = variantsOf(card).find(function (v) { return v.options[cp] === sw.dataset.sdsColor && v.img; });
      var img = card.querySelector('[data-sds-img]'); if (img && withImg) { img.src = withImg.img; img.removeAttribute('srcset'); }
      markSizes(card); return;
    }
    var tg = t.closest('[data-sds-quick-toggle]');
    if (tg) { tg.closest('[data-sds-product]').classList.add('is-open'); return; }
    var sz = t.closest('[data-sds-size]');
    if (sz) {
      var card2 = sz.closest('[data-sds-product]');
      var v = findVariant(card2, sz.dataset.sdsSize);
      if (!v || !v.available) { msg(card2, 'Épuisé dans cette taille', 1600); return; }
      card2.dataset.size = sz.dataset.sdsSize; card2.dataset.variant = v.id; card2.classList.remove('sds-need');
      markSizes(card2);
      if (card2.classList.contains('is-select')) { msg(card2, 'Taille ' + sz.dataset.sdsSize + ' sélectionnée'); updateSet(card2.closest('[data-sds-set-root]')); return; }
      msg(card2, 'Ajout…');
      addToCart([{ id: v.id, quantity: 1 }]).then(function () { msg(card2, 'Ajouté au panier ✓', 1800); }).catch(function (err) { msg(card2, err.message, 2500); });
      return;
    }
    var af = t.closest('[data-sds-add-first]');
    if (af) {
      var card3 = af.closest('[data-sds-product]');
      addToCart([{ id: +af.dataset.sdsAddFirst, quantity: 1 }]).then(function () { msg(card3, 'Ajouté au panier ✓', 1800); }).catch(function (err) { msg(card3, err.message, 2500); });
      return;
    }
    var set = t.closest('[data-sds-set]');
    if (set) { buySet(set.closest('[data-sds-set-root]'), set); return; }
    var tab = t.closest('[data-sds-tab]');
    if (tab) {
      var r = tab.closest('[data-sds-tabs-root]'); var i = tab.dataset.sdsTab;
      r.querySelectorAll('[data-sds-tab]').forEach(function (b) { b.classList.toggle('is-on', b === tab); });
      r.querySelectorAll('[data-sds-panel]').forEach(function (p) { p.hidden = p.dataset.sdsPanel !== i; });
      return;
    }
    var op = t.closest('[data-sds-open]');
    if (op) { var d = document.getElementById(op.dataset.sdsOpen); if (d && d.showModal) d.showModal(); return; }
    var cl = t.closest('[data-sds-close]');
    if (cl) { var dd = cl.closest('dialog'); if (dd) dd.close(); return; }
    if (t.tagName === 'DIALOG' && t.classList.contains('sds-look')) { t.close(); }
  });

  /* ---------- SHOP THE LOOK : acheter le set ---------- */
  function updateSet(rootEl) {
    if (!rootEl) return; var btn = rootEl.querySelector('[data-sds-set]'); if (!btn) return;
    var cards = [].slice.call(rootEl.querySelectorAll('[data-sds-product]'));
    var ready = cards.filter(function (c) { return c.dataset.variant; });
    if (!btn.dataset.base) btn.dataset.base = btn.textContent;
    btn.textContent = ready.length === cards.length ? btn.dataset.base : 'CHOISISSEZ VOS TAILLES (' + ready.length + '/' + cards.length + ')';
  }
  function buySet(rootEl, btn) {
    var cards = [].slice.call(rootEl.querySelectorAll('[data-sds-product]'));
    var missing = cards.filter(function (c) { return !c.dataset.variant && c.querySelector('[data-sds-size]'); });
    if (missing.length) {
      cards.forEach(function (c) { c.classList.add('is-select'); });
      missing.forEach(function (c) { c.classList.add('sds-need'); });
      updateSet(rootEl); return;
    }
    var items = cards.map(function (c) {
      var id = c.dataset.variant || (c.querySelector('[data-sds-add-first]') || {}).dataset;
      if (typeof id === 'object') id = id && id.sdsAddFirst;
      return { id: +id, quantity: 1 };
    }).filter(function (x) { return x.id; });
    if (!btn.dataset.base) btn.dataset.base = btn.textContent;
    btn.textContent = 'AJOUT…';
    addToCart(items).then(function () {
      btn.textContent = 'LOOK AJOUTÉ AU PANIER ✓'; btn.classList.add('is-done');
      setTimeout(function () { btn.textContent = btn.dataset.base; btn.classList.remove('is-done'); }, 2200);
    }).catch(function (err) { btn.textContent = err.message; setTimeout(function () { btn.textContent = btn.dataset.base; }, 2500); });
  }

  /* ---------- VIDÉOS ---------- */
  document.querySelectorAll('video[data-sds-rate]').forEach(function (v) {
    var r = +v.dataset.sdsRate || 1; var set = function () { v.playbackRate = r; };
    v.muted = true; set(); v.addEventListener('loadedmetadata', set); v.addEventListener('play', set);
    v.play && v.play().catch(function () {});
  });
  document.querySelectorAll('[data-sds-loop]').forEach(function (box) {
    var vids = [].slice.call(box.querySelectorAll('video')); if (!vids.length) return;
    var rate = +box.dataset.rate || 1, cut = +box.dataset.cut || 0.5, flash = box.querySelector('[data-sds-flash]');
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      var set = function () { v.playbackRate = rate; };
      set(); v.addEventListener('loadedmetadata', set); v.addEventListener('play', set);
    });
    vids[0].play().catch(function () {});
    if (vids.length < 2) { vids[0].loop = true; return; }
    var act = 0, sw = false, canRead = true, lc = 0;
    var cv = document.createElement('canvas'); cv.width = 16; cv.height = 9; var cx = cv.getContext('2d', { willReadFrequently: true });
    function dark(v) {
      if (!canRead) return false;
      try { cx.drawImage(v, 0, 0, 16, 9); var d = cx.getImageData(0, 0, 16, 9).data, s = 0; for (var i = 0; i < d.length; i += 4) s += d[i] + d[i + 1] + d[i + 2]; return s / (d.length / 4) / 3 < 14; }
      catch (e) { canRead = false; return false; }
    }
    function swap() {
      var cur = vids[act], nxt = vids[1 - act]; sw = true;
      if (flash) { flash.style.transition = 'opacity .09s ease-out'; flash.style.opacity = 1; }
      setTimeout(function () {
        nxt.currentTime = 0; nxt.playbackRate = rate; nxt.play().catch(function () {});
        nxt.classList.add('is-active'); cur.classList.remove('is-active'); cur.pause();
        if (flash) { flash.style.transition = 'opacity .5s ease-out'; flash.style.opacity = 0; }
        act = 1 - act; setTimeout(function () { sw = false; }, 500);
      }, flash ? 110 : 0);
    }
    (function tick() {
      var v = vids[act];
      if (v.duration && !sw && !v.paused) {
        var left = v.duration - v.currentTime, now = performance.now(), dk = false;
        if (v.currentTime > 1.5 && left < 4 && now - lc > 120) { lc = now; dk = dark(v); }
        if (dk || left < cut) swap();
      } else if (v.ended && !sw) swap();
      requestAnimationFrame(tick);
    })();
  });

  /* ---------- PAGE PRODUIT ---------- */
  document.querySelectorAll('[data-sds-pdp]').forEach(function (rootEl) {
    var V = JSON.parse(rootEl.querySelector('[data-sds-variants]').textContent);
    var cp = +rootEl.dataset.colorPos, sp = +rootEl.dataset.sizePos, low = +rootEl.dataset.low || 3;
    var reqSize = rootEl.dataset.requireSize === 'true' && sp >= 0;
    var cur = V.find(function (v) { return v.id === +rootEl.dataset.current; }) || V[0];
    var sel = cur ? cur.options.slice() : [];
    if (reqSize && !/[?&]variant=/.test(location.search)) sel[sp] = null;
    var q = function (s) { return rootEl.querySelector(s); };
    var idIn = q('[data-sds-id]'), btn = q('[data-sds-submit]'), price = q('[data-sds-price]'), cmp = q('[data-sds-compare]'), inst = q('[data-sds-inst]'), stock = q('[data-sds-stock]');
    var label = btn ? (btn.dataset.label || 'AJOUTER AU PANIER') : '';
    var inStock = rootEl.dataset.instock || 'En stock';
    var figs = [].slice.call(rootEl.querySelectorAll('[data-sds-fig]'));
    function match(o) { return V.find(function (v) { return v.options.every(function (x, i) { return x === o[i]; }); }); }
    function update() {
      var v = sel.every(function (x) { return x != null; }) ? match(sel) : null;
      rootEl.querySelectorAll('[data-sds-opt]').forEach(function (box) {
        var p = +box.dataset.sdsOpt;
        box.querySelectorAll('[data-value]').forEach(function (b) {
          b.classList.toggle('is-on', b.dataset.value === sel[p]);
          var test = sel.slice(); test[p] = b.dataset.value;
          var any = V.filter(function (x) { return test.every(function (y, i) { return y == null || x.options[i] === y; }); });
          b.classList.toggle('is-out', !any.some(function (x) { return x.available; }));
        });
        var l = box.querySelector('[data-sds-opt-label]'); if (l) l.textContent = sel[p] || 'choisissez';
      });
      if (!btn) return;
      if (!v) {
        btn.disabled = false; btn.textContent = sel[sp] == null && sp >= 0 ? 'CHOISIR UNE TAILLE' : 'INDISPONIBLE';
        if (stock) stock.textContent = inStock;
      } else {
        idIn.value = v.id;
        if (price) price.textContent = fmt(v.price);
        if (cmp) { cmp.textContent = v.compare > v.price ? fmt(v.compare) : ''; }
        if (inst) inst.textContent = fmt(Math.round(v.price / 3));
        btn.disabled = !v.available;
        btn.textContent = v.available ? label + ' — ' + fmt(v.price) : 'ÉPUISÉ';
        if (stock) stock.textContent = !v.available ? 'Épuisé dans cette taille' : (v.inv != null && v.inv <= low ? 'Plus que ' + v.inv + (sp >= 0 ? ' en taille ' + v.options[sp] : ' en stock') : inStock);
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      }
      if (cp >= 0 && figs.length) {
        var c = (sel[cp] || '').toLowerCase().trim();
        var m = figs.filter(function (f) { return (f.dataset.alt || '').toLowerCase().trim() === c; });
        var first = true;
        figs.forEach(function (f) { var show = !m.length || m.indexOf(f) > -1; f.hidden = !show; f.classList.toggle('is-first', show && first); if (show) first = false; });
      }
    }
    rootEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sds-opt] [data-value]');
      if (b) { sel[+b.closest('[data-sds-opt]').dataset.sdsOpt] = b.dataset.value; rootEl.classList.remove('sds-need-size'); update(); return; }
      if (e.target.closest('[data-sds-guide]')) { var g = q('[data-sds-guide-body]'); if (g) g.hidden = !g.hidden; return; }
      var w = e.target.closest('[data-sds-wish]'); if (w) { w.classList.toggle('is-on'); }
    });
    var form = q('[data-sds-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = sel.every(function (x) { return x != null; }) ? match(sel) : null;
      if (!v) { rootEl.classList.add('sds-need-size'); return; }
      if (!v.available) return;
      btn.disabled = true; btn.textContent = 'AJOUT…';
      addToCart([{ id: v.id, quantity: 1 }]).then(function () {
        btn.disabled = false; btn.textContent = 'AJOUTÉ AU PANIER ✓'; btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); update(); }, 1800);
      }).catch(function (err) { btn.disabled = false; btn.textContent = err.message; setTimeout(update, 2500); });
    });
    update();
  });
})();
